<template>
  <v-container 
    fill-height
    class="py-0"
  >
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-text class="pa-0">
            <v-container class="py-0">
              <v-row>
                <v-col
                  cols="12"
                  md="4"
                >
                  <transition
                    appear
                    name="slide-fade"
                  >
                    <Sidebar />
                  </transition>
                </v-col>
                <v-col>
                  <Content />
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12">
        <Footer />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Footer from '@/views/Footer'
import Content from '@/components/content/Content';
import Sidebar from '@/components/sidebar/Sidebar';

export default {
  name: 'Resume',
  components: {
    Footer,
    Content,
    Sidebar,
  },
  data: () => ({}),
};
</script>

<style scoped>
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
</style>